<div class="text-center">
  <div class="spinner-border mt-5" style="width: 3rem; height: 3rem;" role="status">
    <span class="sr-only"></span>
  </div>
  <h3 class="mb-5">{{message}}...</h3>
</div>
